'use client';

import { RoundedBanner } from '@/app/components/server/rounded-banner';
import type { DatoButtonBlock, DatoModuleFormat } from '@/lib/datocms';

import type { FlexProps } from '@ironhack/design-system2/components';
import type { ReactElement } from 'react';
import type { StructuredTextGraphQlResponse } from 'react-datocms';

export type Banner = {
  button: [DatoButtonBlock];
  content: StructuredTextGraphQlResponse;
  title: string;
};

type Props = { data: Banner } & FlexProps;

export const Banner = (props: Props): ReactElement => {
  const {
    data: { button, content, title },
    ...flexProps
  } = props;

  const roundedBannerData = {
    button,
    content,
    moduleFormat: [
      { background: 'white', spacingBottom: '40', spacingTop: '40' },
    ] as [DatoModuleFormat],
    title,
  };

  return <RoundedBanner as="section" data={roundedBannerData} {...flexProps} />;
};
